import { recipesEs } from './recipes-es';
import { batchScalingEs, processRoutingEs } from './process-routing-es';
import { declarationsEs } from './declarations-es';
import { analysisEs } from './analysis-es';

export const plmEs = {
  material: {
    tab: 'Desarrollo de producto',
    roles: {
      TRADING_GOOD: 'Mercancía',
      RAW_MATERIAL: 'Materia prima',
      SEMI_FINISHED: 'Semielaborado',
      FINISHED_GOOD: 'Producto terminado',
      PACKAGING_MATERIAL: 'Material de embalaje',
      OPERATING_SUPPLY: 'Consumible',
      BY_PRODUCT: 'Subproducto',
    },
    sections: {
      roles: 'Roles de uso',
      versions: 'Perfiles maestros versionados',
      translations: 'Denominaciones multilingües',
    },
    help: {
      roles:
        'Un artículo puede tener varios roles a la vez. Los cambios se guardan con control de versión.',
      structuredJson:
        'Claves y valores estructurados como objeto JSON válido. Introduzca los números de cálculo como cadenas decimales.',
      conversions:
        'Lista JSON con fromUnitCode, toUnitCode, factor, offset, roundingScale y usesDensity.',
      dms: 'Solo se pueden seleccionar archivos del expediente DMS protegido de este artículo.',
    },
    messages: {
      saved: 'Versión de datos maestros guardada.',
      invalid: 'Los datos no son válidos.',
      rolesSaved: 'Roles guardados.',
      workflowUpdated: 'Flujo actualizado.',
      submitted: 'Versión enviada a revisión.',
    },
    states: {
      noApproved: 'Aún no hay una versión maestra aprobada.',
      approvedVersion: 'Versión aprobada: v{{version}}',
      empty: 'Aún no existe ninguna versión.',
      noDocuments: 'El expediente del artículo aún no contiene archivos DMS.',
    },
    actions: {
      newVersion: 'Nueva versión',
      submit: 'Enviar a revisión',
      approve: 'Aprobar',
      copy: 'Copiar a nueva versión',
      archive: 'Archivar',
      confirm: 'Confirmar',
    },
    columns: {
      version: 'Versión',
      status: 'Estado',
      validity: 'Vigencia',
      names: 'Denominación',
      suppliers: 'Instantánea de proveedores',
    },
    statuses: {
      DRAFT: 'Borrador',
      IN_REVIEW: 'En revisión',
      APPROVED: 'Aprobado',
      SUPERSEDED: 'Sustituido',
      ARCHIVED: 'Archivado',
    },
    editor: {
      createTitle: 'Crear versión maestra',
      editTitle: 'Editar versión maestra v{{version}}',
      description:
        'Las versiones aprobadas son inmutables. Los proveedores se capturan en el servidor al guardar.',
    },
    fields: {
      usageRoles: 'Roles de uso',
      standardUnit: 'Unidad estándar',
      shelfLifeDays: 'Vida útil (días)',
      density: 'Densidad',
      densityUnit: 'Unidad de densidad',
      originCountry: 'País de origen',
      originRegion: 'Región de origen',
      manufacturer: 'Fabricante',
      manufacturerAddress: 'Dirección del fabricante',
      validFrom: 'Válido desde',
      validTo: 'Válido hasta',
      internalName: 'Denominación interna',
      externalName: 'Denominación externa',
      declarationName: 'Denominación de declaración',
      storageInstructions: 'Instrucciones de almacenamiento',
      technicalProperties: 'Propiedades técnicas',
      qualityProperties: 'Propiedades de calidad',
      storageConditions: 'Condiciones de almacenamiento',
      foodProfile: 'Perfil alimentario opcional',
      nutritionProfile: 'Perfil nutricional opcional',
      allergenInformation: 'Información opcional de alérgenos',
      additiveInformation: 'Información opcional de aditivos',
      extensionProfiles: 'Perfiles sectoriales adicionales',
      conversions: 'Factores de conversión del artículo',
      dmsDocuments: 'Documentos DMS y especificaciones de proveedor',
      changeReason: 'Motivo del cambio',
      reason: 'Justificación',
    },
    actionDialog: {
      APPROVE: {
        title: 'Aprobar datos maestros',
        description:
          'La aprobación es auditable y requiere un usuario distinto del creador y remitente.',
      },
      COPY: {
        title: 'Crear nueva versión',
        description:
          'El contenido se copia a un nuevo borrador y los proveedores se capturan de nuevo.',
      },
      ARCHIVE: {
        title: 'Archivar versión',
        description:
          'La versión sigue siendo totalmente trazable, pero deja de utilizarse activamente.',
      },
    },
  },
  recipes: recipesEs,
  processRouting: processRoutingEs,
  batchScaling: batchScalingEs,
  declarations: declarationsEs,
  analysis: analysisEs,
} as const;
